import { List, ListItemButton, ListItemText } from "@mui/material";
import { isSameDay } from "date-fns";
import React from "react";
import { DateRange, DefinedRange } from "../types";

type DefinedRangesProps = {
  setRange: (range: DateRange) => void;
  selectedRange: DateRange;
  ranges: DefinedRange[];
  verticalOrientation: boolean;
};

const isSameRange = (first: DateRange, second: DateRange) => {
  const { startDate: fStart, endDate: fEnd } = first;
  const { startDate: sStart, endDate: sEnd } = second;
  if (fStart && sStart && fEnd && sEnd) {
    return isSameDay(fStart, sStart) && isSameDay(fEnd, sEnd);
  }
  return false;
};

const DefinedRanges: React.FunctionComponent<DefinedRangesProps> = ({
  ranges,
  setRange,
  selectedRange,
  verticalOrientation,
}: DefinedRangesProps) => (
  <List
    disablePadding
    sx={{
      flexDirection: verticalOrientation ? "row" : "column",
      display: "flex",
      overflowY: "scroll",
      minWidth: 110,
    }}
  >
    {ranges.map((range, idx) => (
      <ListItemButton
        key={idx}
        onClick={() => setRange(range)}
        sx={[
          isSameRange(range, selectedRange) && {
            backgroundColor: (theme) => theme.palette.primary.main,
            color: "primary.contrastText",
            "&:hover": {
              color: "inherit",
            },
          },
        ]}
      >
        <ListItemText
          primaryTypographyProps={{
            variant: "body1",
            sx: {
              fontWeight: isSameRange(range, selectedRange) ? "bold" : "normal",
            },
          }}
        >
          {range.label}
        </ListItemText>
      </ListItemButton>
    ))}
  </List>
);

export default DefinedRanges;
